/* eslint-disable */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useConversation } from "@lobees/chat-core";

import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

import ConversationRightContactChatPanel from "./ConversationRightContactChatPanel";
import { assetImages } from "constants";
import ConversationProfileDetailsPopup from "components/ConversationComponents/Popups/ConversationProfileDetailsPopup";
import ChatAiSummaryModal from "components/ConversationComponents/Modals/ChatAiSummaryModal";
import ChatAiMedicalHelp from "components/ConversationComponents/Modals/ChatAiMedicalHelpModal";
import SendEmailPopup from "components/common/Popup/SendEmailPopup";

//import ConversationRightContactMailPanel from './ConversationRightContactMailPanel';

// import AskPayment from "components/common/Modals/AskPayment";
// import ConversationHistoryModal from "components/ConversationComponents/Modals/ConversationHistoryModal";

const ConversationRightContactPanel = ({
  //history modal states
  setShowHistory,
  setChatSearchMessage,

  //reload chat after ask payment close
  reloadChatAfterPayment = false,
  setReloadChatAfterPayment = () => {},
}) => {
  // Conversation identity + the raw socket used to arrive as ~15 separate
  // props threaded from ConversationBody's own state; both now live in the
  // shared conversation context. `ConversationRightContactChatPanel` below is
  // not yet rewritten to consume the package's hooks directly (that's a
  // follow-up), so this bridges the same prop shape it already expects,
  // sourced from context instead of from removed ConversationBody state.
  const { conversation, adapter } = useConversation();
  const selectedContactUserId = conversation?.id;
  const conversationName = conversation?.name ?? "";
  const selectedChatLogo = conversation?.logo ?? "";
  const selectedChatEmail = conversation?.email ?? "";
  const selectedChatRoomId = conversation?.roomId ?? null;
  const selectedChatPhone = conversation?.phone ?? "";
  const selectedChatAddress = conversation?.address ?? "";
  const selectedChatCompany = conversation?.company ?? "";
  const chatcomponentSlug = conversation?.component?.slug ?? "";
  const chatComponentTitle = conversation?.component?.title ?? "";
  const chatComponentId = conversation?.component?.id ?? null;
  const socket = adapter?.getRawSocket?.();
  // Never actually called by ConversationRightContactChatPanel today (it only
  // reads these values), kept as no-ops purely to satisfy its existing prop
  // signature until that file is rewritten to consume the package directly.
  const setchatcomponentSlug = () => {};
  const setchatComponentTitle = () => {};
  const setchatComponentId = () => {};
  const mobileCloseChatHandler = () => {
    document.body.classList.toggle("chatmsg_open");
  };

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  //search message requirements
  const [displaySearchPanel, setdisplaySearchPanel] = useState(false);
  const [searchMessage, setsearchMessage] = useState("");
  const [refreshMessages, setrefreshMessages] = useState(false);

  const [getSearchMessage, setgetSearchMessage] = useState(false);

  const [isLoading, setisLoading] = useState(false);
  const [emails, setEmails] = useState("");
  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [position, setPosition] = useState("");

  //function for get user details
  const getUserDetails = async () => {
    try {
      setisLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${selectedContactUserId}` +
        ``;

      // console.log("requestUrl", requestUrl);

      const response = await getData(requestUrl);

      setisLoading(false);

      // console.log("response", response);

      if (response.status && response.data) {
        const data = response.data;

        setName(data.name || "");
        setSurName(data.surname || "");
        setEmail(data.email || "");
        setTelephone(data.phone || "");
        setPosition(data.position || "");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for reset all chats
  const refreshChatHandler = () => {
    setrefreshMessages(true);
    setdisplaySearchPanel(false);
    setsearchMessage("");
    if (selectedContactUserId) {
      getUserDetails();
    }
  };

  //function for search messages
  const searchMessageHandler = () => {
    setgetSearchMessage(true);
    setdisplaySearchPanel(false);
  };

  const searchMessageByEnter = (e) => {
    if (e.key === "Enter") {
      searchMessageHandler();
    }
  };

  useEffect(() => {
    if (reloadChatAfterPayment) {
      refreshChatHandler();
      setReloadChatAfterPayment(false);
    }
  }, [reloadChatAfterPayment]);

  useEffect(() => {
    if (selectedContactUserId) {
      getUserDetails();
    }
  }, [selectedContactUserId]);

  // Add function to handle payment button click
  const handlePaymentClick = (e) => {
    e.preventDefault(); // Prevent default link behavior

    const modalElement = document.getElementById("askPaymentModal");
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  };

  const handleAiSummaryClick = (e) => {
    e.preventDefault();
    let myModal = new bootstrap.Modal(document.getElementById("chataisummary"));
    myModal.show();
  };

  const handleMedicalHelpClick = (e) => {
    e.preventDefault();
    let myModal = new bootstrap.Modal(
      document.getElementById("chataimedicalhelp")
    );
    myModal.show();
  };

  const handleSendMailClick = (e) => {
    e.preventDefault();
    setEmails(selectedChatEmail);
    document.body.classList.toggle("emailpopup_open");
  };

  // // add a useEffect to log paymentUserData changes and open the modal
  // useEffect(() => {
  //   console.log("paymentUserData updated:", paymentUserData);
  //   if (paymentUserData.userid) {
  //     const modalElement = document.getElementById('askPaymentModal');
  //     if (modalElement) {
  //       console.log("Opening AskPayment modal");
  //       const modal = new bootstrap.Modal(modalElement);
  //       modal.show();
  //     }
  //   }
  // }, [paymentUserData]);

  return (
    <>
      <div className="chat_topPnl">
        <div className="chatusr_info">
          <div className="list_back">
            <Link to="#" onClick={mobileCloseChatHandler}>
              <i className="material-icons-round">arrow_back</i>
            </Link>
          </div>
          {isLoading ? (
            <div className="grp_userHead placeholder-glow">
              <div className="user_placeHoledr">
                <div className="default_usr">
                  <img src={assetImages.defaultUser} alt="" />
                </div>
                <div className="default_usr_name">
                  <span className="placeholder placeholder-sm col-5 rounded-3"></span>
                  <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                </div>
              </div>
            </div>
          ) : (
            <Link
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#profile_pnl"
              className="chat_usrOuter profile_linkBtn"
            >
              <div className="chat_usrPic">
                <img
                  height="40"
                  className="rounded-circle"
                  src={
                    isLoading
                      ? assetImages.defaultUser
                      : selectedChatLogo == ""
                      ? assetImages.defaultUser
                      : url.SERVER_URL + selectedChatLogo
                  }
                  alt=""
                />
              </div>

              <div className="chat_usrtext">
                <h3>
                  {name} {surName}
                </h3>
                <h5>{position}</h5>
              </div>
            </Link>
          )}

          <div className="info_icons me-2">
            <ul className="list_stye_none">
              {/* Refresh */}
              <li>
                <Link to="#" onClick={refreshChatHandler}>
                  <i className="material-icons-round">refresh</i>
                </Link>
              </li>

              {/* add ask payment */}
              <li>
                <Link to="#" onClick={handlePaymentClick}>
                  <i className="material-icons-round">payment</i>
                </Link>
              </li>

              {/* AI Summary */}
              <li>
                <Link to="#" onClick={handleAiSummaryClick} title="AI Summary">
                  <i className="material-icons-round">psychology</i>
                </Link>
              </li>

              {/* Medical Help */}
              <li>
                <Link
                  to="#"
                  onClick={handleMedicalHelpClick}
                  title="Medical Help"
                >
                  <i className="material-icons-round">medical_services</i>
                </Link>
              </li>

              {/* Send Mail */}
              <li>
                <Link to="#" onClick={handleSendMailClick} title="Send Mail">
                  <i className="material-icons-round">email</i>
                </Link>
              </li>

              {/* Search */}
              <li>
                <Link
                  to="#"
                  className="srch_Btn_icon"
                  onClick={() => {
                    setdisplaySearchPanel(!displaySearchPanel);
                    setsearchMessage("");
                  }}
                >
                  <i className="material-icons-round">search</i>
                </Link>
              </li>

              {/* Chat History */}
              <li>
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#chathistorymodal"
                  onClick={() => {
                    setShowHistory(true);
                    setChatSearchMessage(searchMessage);
                  }}
                >
                  <i className="material-icons-round">history</i>
                </Link>
              </li>

              {/* <li>
                <Link to="#">
                  <i className="material-icons-round">person_add</i>
                </Link>
              </li> */}
            </ul>
          </div>
        </div>

        {/* <div className="chat_tablinks">
          <ul className="list_stye_none">
            <li className="active">
              <Link to="#">
                <i className="material-icons-round">question_answer</i>
                <span>chat</span>
              </Link>
            </li>
          </ul>
        </div> */}

        <div
          className="serch_pnl"
          style={{
            display: displaySearchPanel ? "block" : "none",
          }}
        >
          <div className="srch_innrFill">
            <input
              type="text"
              className="form-control"
              placeholder="Search for conversation"
              value={searchMessage}
              onChange={(e) => {
                setsearchMessage(e.target.value);
              }}
              onKeyDown={searchMessageByEnter}
            />
            <button
              className="srch_submitBtn"
              type="button"
              onClick={searchMessageHandler}
            >
              <i className="material-icons-round"> send</i>
            </button>
          </div>
        </div>
      </div>

      <ConversationRightContactChatPanel
        conversationName={conversationName}
        selectedContactUserId={selectedContactUserId}
        selectedChatEmail={selectedChatEmail}
        selectedChatLogo={selectedChatLogo}
        selectedChatRoomId={selectedChatRoomId}
        chatcomponentSlug={chatcomponentSlug}
        setchatcomponentSlug={setchatcomponentSlug}
        chatComponentTitle={chatComponentTitle}
        setchatComponentTitle={setchatComponentTitle}
        chatComponentId={chatComponentId}
        setchatComponentId={setchatComponentId}
        socket={socket}
        searchMessage={searchMessage}
        setsearchMessage={setsearchMessage}
        getSearchMessage={getSearchMessage}
        setgetSearchMessage={setgetSearchMessage}
        refreshMessages={refreshMessages}
        setrefreshMessages={setrefreshMessages}
      />

      {/* <ConversationRightContactMailPanel /> */}

      <ConversationProfileDetailsPopup
        conversationName={conversationName}
        selectedChatLogo={selectedChatLogo}
        selectedChatEmail={selectedChatEmail}
        selectedChatPhone={selectedChatPhone}
        selectedChatAddress={selectedChatAddress}
        selectedChatCompany={selectedChatCompany}
      />

      <ChatAiSummaryModal
        roomId={selectedContactUserId}
        isGroupChat={false}
      />

      <ChatAiMedicalHelp
        roomId={selectedContactUserId}
        isGroupChat={false}
      />

      <SendEmailPopup emails={emails} setEmails={setEmails} />

      {/* <ConversationHistoryModal
        showHistory={showHistory}
        isGroupChat={false}
        setShowHistory={setShowHistory}
        selectedChatRoomId={selectedContactUserId} // here we send contact id instead of room id
        searchMessage={searchMessage}
      /> */}

      {/* <AskPayment
        userid={selectedContactUserId}
        userName={conversationName}
        userImage={selectedChatLogo}
        userEmail={selectedChatEmail}
        onClose={refreshChatHandler}
      /> */}
    </>
  );
};

export default ConversationRightContactPanel;
